angular.module('property')
    .component('propertyTypeSelect', {
        bindings: {
            onChange: '&',
            required: "="
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <select id="type" class="form-control" ng-model="$ctrl.selected" ng-options="('property.type.' + u | translate) for u in $ctrl.items" ng-change="$ctrl.onSelectionChanged()" ng-required="$ctrl.required">
                <option value="" translate="property.type.select"></option>
            </select>
        `,
        controller: function (Property) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.items = Property.types()

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => viewValue);
            };

            ctrl.onSelectionChanged = () => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();

                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()(ctrl.selected);
                }
            };

        }
    })
